module.exports = __webpack_public_path__ + "img/advertising-1.6cfd3859.png";